<script>

import { mapActions, mapGetters } from 'vuex';
import MobileDetect from 'mobile-detect';
import { VERSION } from '@/utils/Constant';
import { addMonth, getCurrentDate } from '@/pages/utils/tool';
import MarketPaymentTool from '@/utils/MarketPaymentTool';
import NoticeManager from '@/utils/notice_manager';

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'common',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentInfo']),
    getVersion() {
      return VERSION;
    },
    isMobile() {
      return md.phone();
    },
    isMaintain() {
      const maintain = parseInt(localStorage.getItem('maintain'), 10);
      return maintain === 1;
    },
    getRequireCheckList() {
      return [
        { key: 'r1', title: '必備一.', option: '必備一', text: '信用卡正常無逾期(需提供近一年帳單)，逾期依據信用卡帳單滯納金判斷。', value: false },
        { key: 'r2', title: '必備二.', option: '必備二', text: '任職上市櫃公司(需為正職員工且現職)', value: false },
      ];
    },
    getCheckList() {
      const newCheckList = [
        { key: 0, title: '一.', text: '正職滿八個月(附勞保卡或薪轉存褶，新增健保快易通知個人投保紀錄查詢截圖，不含公會投保)', value: false },
        { key: 1, title: '二.', text: '申請人或保人自有不動產(排除山坡保育地)、近一年無增貸-依進件日為主，無三胎(含)以上設定且無銀行私設(含集團TAC、新鑫)，申+保需持 份全部。', value: false },
        { key: 2, title: '三.', text: '三等親屬保(該親屬保年齡限65歲(含)以下)或正職保人(正職定義同第一項)', value: false },
        { key: 3, title: '四.', text: '申請人任職上市櫃公司或軍公教(需為正式員工且現職)', value: false },
        { key: 4, title: '五.', text: '申請人或保人持有甲乙丙級術士之專業證照，且該證照需與現職具備相關性', value: false },
        { key: 5, title: '六.', text: '提供近15天 內(含)個人JCIC(連徵信用正常，不包括小白)', value: false },
      ];
      newCheckList.push({ key: 6, title: '七.', text: '持信用卡正卡，且無逾期(提供近一期帳單)，逾期依據信用卡帳單滯納金判斷', value: false });
      newCheckList.push({ key: 7, title: '八.', text: '三個月內CCIS無查詢紀錄(含裕富)', value: false });
      newCheckList.push({ key: 8, title: '九.', text: '既有客戶(正常繳滿六期以上且無八天(含)以上逾期紀錄) ---【此項條件不適用借新還舊專案】', value: false });
      newCheckList.push({ key: 9, title: '十.', text: '提供申請人同業(含集團TAC、新鑫)繳費狀況(正常繳滿八期以上，且任一期繳費日不可逾期超過八日)---【此項條件僅適用原車/借舊，代償案件 無此條件】', value: false });
      return newCheckList;
    },
    sealSelfList() {
      return [
        { key: 0, value: '否' },
        { key: 1, value: '是' },
      ];
    },
    tradeTypeList() {
      return [
        { key: 0, value: '機車' },
        { key: 1, value: '汽車' },
      ];
    },
    tradeStatusList() {
      return [
        { key: 0, value: '拉車' },
        { key: 1, value: '過戶' },
        { key: 2, value: '過回' },
      ];
    },
    getCaseStatusList() { // 0進件中 1婉拒 2待捕
      return [
        { key: 0, value: '待進件' },
        { key: 5, value: '已進件' },
        { key: 1, value: '婉拒' },
        { key: 2, value: '待捕' },
        { key: 3, value: '核准' },
        { key: 4, value: '附條件' },
        { key: 6, value: '已請款' },
        { key: 7, value: '原融已請款' },
        { key: 8, value: '原融已撥款' },
        { key: 9, value: '申覆' },
        { key: 10, value: '自退' },
        { key: 11, value: '撥款問題件' },
        { key: 12, value: '已結案' },
      ];
    },
    getPaymentStatusList() { // 0進件中 1婉拒 2待捕
      return [
        { key: 7, value: '已請款' },
        { key: 8, value: '已撥款' },
        // { key: 9, value: '已申覆' },
      ];
    },
    getPriorityStatusList() {
      return [
        { key: 0, value: '待處理' },
        { key: 1, value: '已處理' },
      ];
    },
    getProductCategoryList() {
      const list = [
        { key: 'AEON1', busType: 'AA21', text: '宏佳騰機車' },
        { key: 'commodity', busType: 'AA21', text: '委外商品' },
        { key: 'E-MOTOR', busType: 'AA21', text: '電動機車' },
        { key: 'E-MOVING', busType: 'AA21', text: '中華電動車-專案' },
        { key: 'GOGORO', busType: 'AA21', text: '睿能' },
        { key: 'HARTFORD1', busType: 'AA21', text: '哈特佛機車' },
        { key: 'HONDA1', busType: 'AA21', text: 'HONDA1' },
        { key: 'KYMCO1', busType: 'AA21', text: '光陽機車' },
        { key: 'OTHER MOTOR', busType: 'AA21', text: '其它廠牌機車' },
        { key: 'PGO1', busType: 'AA21', text: '比雅久' },
        { key: 'SUZUKI1', busType: 'AA21', text: '台鈴機車' },
        { key: 'SYM1', busType: 'AA21', text: '三陽機車' },
        { key: 'VESPA1', busType: 'AA21', text: '偉士牌機車' },
        { key: 'YAMAHA1', busType: 'AA21', text: '山葉' },

        { key: 'AEON1', busType: 'AA22', text: '宏佳騰機車' },
        { key: 'commodity', busType: 'AA22', text: '委外商品' },
        { key: 'E-MOTOR', busType: 'AA22', text: '電動機車' },
        { key: 'E-MOVING', busType: 'AA22', text: '中華電動車-專案' },
        { key: 'GOGORO', busType: 'AA22', text: '睿能' },
        { key: 'HARTFORD1', busType: 'AA22', text: '哈特佛機車' },
        { key: 'HONDA1', busType: 'AA22', text: 'HONDA1' },
        { key: 'KYMCO1', busType: 'AA22', text: '光陽機車' },
        { key: 'OTHER MOTOR', busType: 'AA22', text: '其它廠牌機車' },
        { key: 'PGO1', busType: 'AA22', text: '比雅久' },
        { key: 'SUZUKI1', busType: 'AA22', text: '台鈴機車' },
        { key: 'SYM1', busType: 'AA22', text: '三陽機車' },
        { key: 'VESPA1', busType: 'AA22', text: '偉士牌機車' },
        { key: 'YAMAHA1', busType: 'AA22', text: '山葉' },

        { key: 'AEON1', busType: 'AA23', text: '宏佳騰機車' },
        { key: 'commodity', busType: 'AA23', text: '委外商品' },
        { key: 'E-MOTOR', busType: 'AA23', text: '電動機車' },
        { key: 'E-MOVING', busType: 'AA23', text: '中華電動車-專案' },
        { key: 'GOGORO', busType: 'AA23', text: '睿能' },
        { key: 'HARTFORD1', busType: 'AA23', text: '哈特佛機車' },
        { key: 'HONDA1', busType: 'AA23', text: 'HONDA1' },
        { key: 'KYMCO1', busType: 'AA23', text: '光陽機車' },
        { key: 'OTHER MOTOR', busType: 'AA23', text: '其它廠牌機車' },
        { key: 'PGO1', busType: 'AA23', text: '比雅久' },
        { key: 'SUZUKI1', busType: 'AA23', text: '台鈴機車' },
        { key: 'SYM1', busType: 'AA23', text: '三陽機車' },
        { key: 'VESPA1', busType: 'AA23', text: '偉士牌機車' },
        { key: 'YAMAHA1', busType: 'AA23', text: '山葉' },

        { key: 'AEON1', busType: 'CA20', text: '宏佳騰機車' },
        { key: 'commodity', busType: 'CA20', text: '委外商品' },
        { key: 'E-MOTOR', busType: 'CA20', text: '電動機車' },
        { key: 'E-MOVING', busType: 'CA20', text: '中華電動車-專案' },
        { key: 'GOGORO', busType: 'CA20', text: '睿能' },
        { key: 'HARTFORD1', busType: 'CA20', text: '哈特佛機車' },
        { key: 'HONDA1', busType: 'CA20', text: 'HONDA1' },
        { key: 'KYMCO1', busType: 'CA20', text: '光陽機車' },
        { key: 'OTHER MOTOR', busType: 'CA20', text: '其它廠牌機車' },
        { key: 'PGO1', busType: 'CA20', text: '比雅久' },
        { key: 'SUZUKI1', busType: 'CA20', text: '台鈴機車' },
        { key: 'SYM1', busType: 'CA20', text: '三陽機車' },
        { key: 'VESPA1', busType: 'CA20', text: '偉士牌機車' },
        { key: 'YAMAHA1', busType: 'CA20', text: '山葉' },
      ];
      return list;
    },
    getCaseTypeList() {
      return [
        { key: 'AA21', text: '機車原車抵押AR', value: 'AA21' },
        { key: 'AA22', text: '機車借新還舊AR', value: 'AA22' },
        { key: 'AA23', text: '機車他行代償AR', value: 'AA23' },
        { key: 'CA20', text: '商品中古分期', value: 'CA20' },
        { key: 'CA21', text: '機車N專案', value: 'AA21' },
      ];
    },
    getSampleCaseTypeList() {
      return [
        { key: '0', value: '原車' },
        { key: '1', value: '借新' },
        { key: '2', value: '代償' },
        { key: '3', value: '商品貸' },
      ];
    },
    getFinanceCaseList() { // 新版專案 2022/12/1/1起
      return [
        // old
        // { key: 'DP63', busType: 'AA21', text: 'DP63-OA機車原融(優加)10％' },
        // { key: 'DP64', busType: 'AA21', text: 'DP64-OA機車原融(優質)10.5%' },
        // { key: 'DP65', busType: 'AA21', text: 'DP65-OA機車原融(一般)14%' },

        // 新 8/1 AA21
        { key: 'DQ74', busType: 'AA21', text: 'DQ74-OA機車原融(超優)13％' },
        { key: 'DQ02', busType: 'AA21', text: 'DQ02-OA機車原融(優加)13.25%' },
        { key: 'DQ03', busType: 'AA21', text: 'DQ03-OA機車原融(優質)13.5%' },

        // old
        // { key: 'DP66', busType: 'AA22', text: 'DP66-OA機車借新還舊(優加)9.5%' },
        // { key: 'DP67', busType: 'AA22', text: 'DP67-OA機車借新還舊(一般)13%' },

        // 新 4/17 AA22
        { key: 'DQ04', busType: 'AA22', text: 'DQ04-OA機車借新還舊(優加)13.25%' },

        // old
        // { key: 'DP68', busType: 'AA23', text: 'DP68-OA機車原融(代償-優加)10％' },
        // { key: 'DP69', busType: 'AA23', text: 'DP69-OA機車原融(代償-優質)10.5%' },
        // { key: 'DP70', busType: 'AA23', text: 'DP70-OA機車原融(代償-一般)14%' },

        // 新 4/17 AA23
        { key: 'DQ05', busType: 'AA23', text: 'DQ05-OA機車原融(代償-超優)13％' },
        { key: 'DQ06', busType: 'AA23', text: 'DQ06-OA機車原融(代償-優加)13.25%' },
        { key: 'DQ07', busType: 'AA23', text: 'DQ07-OA機車原融(代償-優質)13.5%' },

        // old
        // { key: 'DN83', busType: 'CA20', text: 'DN83-OA商品原融(優加)12％' },
        // { key: 'DO91', busType: 'CA20', text: 'DO91-OA商品原融(超優)10％' },
        // { key: 'DN84', busType: 'CA20', text: 'DN84-OA商品原融(優質)11％' },
        // { key: 'DN85', busType: 'CA20', text: 'DN85-OA商品原融(一般)14％' },

        // 新 8/1 CA20
        // { key: 'DQ77', busType: 'CA20', text: 'DQ77-OA商品原融(超優)13.5％' },
        // { key: 'DQ78', busType: 'CA20', text: 'DQ78-OA商品原融(優質)14％' },
        // { key: 'DQ79', busType: 'CA20', text: 'DQ79-OA商品原融(一般)15％' },
        // { key: 'DQ71', busType: 'AA21', text: 'DQ71-OA機車原融(N專案)_超優13.5％' },
        // { key: 'DQ72', busType: 'AA21', text: 'DQ72-OA機車原融(N專案)_優質14％' },
        // { key: 'DQ73', busType: 'AA21', text: 'DQ73-OA機車原融(N專案)_一般15％' },
        { key: 'DR47', busType: 'AA21', text: 'DR47-OA機車原融(N專案)_超優13.5％' },
        { key: 'DR48', busType: 'AA21', text: 'DR48-OA機車原融(N專案)_優質14％' },
        { key: 'DR49', busType: 'AA21', text: 'DR49-OA機車原融(N專案)_一般15％' },

        // 嘉好自有
        { key: 'CC210', busType: 'CC21', text: '新車分期' },
        { key: 'CC220', busType: 'CC21', text: '中古車分期' },
        { key: 'CC220', busType: 'CC21', text: '延長期數專案' },

        // 21世紀
        { key: 'C021', busType: 'C21', text: '商品原融' },
      ];
    },
    getCAFinanceCaseList() { // 新 8/9 CA20
      return [
        // { key: 'DQ71', busType: 'AA21', text: 'DQ71-OA機車原融(N專案)_超優13.5％' },
        // { key: 'DQ72', busType: 'AA21', text: 'DQ72-OA機車原融(N專案)_優質14％' },
        // { key: 'DQ73', busType: 'AA21', text: 'DQ73-OA機車原融(N專案)_一般15％' },
        // { key: 'DQ77', busType: 'CA20', text: 'DQ77-OA商品原融(超優)13.5％' },
        // { key: 'DQ78', busType: 'CA20', text: 'DQ78-OA商品原融(優質)14％' },
        // { key: 'DQ79', busType: 'CA20', text: 'DQ79-OA商品原融(一般)15％' },
        { key: 'DR47', busType: 'AA21', text: 'DR47-OA機車原融(N專案)_超優13.5％' },
        { key: 'DR48', busType: 'AA21', text: 'DR48-OA機車原融(N專案)_優質14％' },
        { key: 'DR49', busType: 'AA21', text: 'DR49-OA機車原融(N專案)_一般15％' },
      ];
    },
    getFinanceCaseViewList() { // 顯示專用
      return [
        // 舊 6/1
        { key: 'DQ01', busType: 'AA21', text: 'DQ01-OA機車原融(超優)13％' },
        // 新 8/1 AA21
        { key: 'DQ74', busType: 'AA21', text: 'DQ74-OA機車原融(超優)13％' },
        { key: 'DQ02', busType: 'AA21', text: 'DQ02-OA機車原融(優加)13.25%' },
        { key: 'DQ03', busType: 'AA21', text: 'DQ03-OA機車原融(優質)13.5%' },

        // 新 4/17 AA23
        { key: 'DQ05', busType: 'AA23', text: 'DQ05-OA機車原融(代償-超優)13％' },
        { key: 'DQ06', busType: 'AA23', text: 'DQ06-OA機車原融(代償-優加)13.25%' },
        { key: 'DQ07', busType: 'AA23', text: 'DQ07-OA機車原融(代償-優質)13.5%' },

        // 舊 6/1 CA20
        { key: 'DQ18', busType: 'CA20', text: 'DQ18-OA商品原融(超優)13％' },
        { key: 'DQ19', busType: 'CA20', text: 'DQ19-OA商品原融(優質)14％' },
        { key: 'DQ20', busType: 'CA20', text: 'DQ20-OA商品原融(一般)15％' },
        // 新 8/1 CA20
        { key: 'DQ77', busType: 'CA20', text: 'DQ77-OA商品原融(超優)13.5％' },
        { key: 'DQ78', busType: 'CA20', text: 'DQ78-OA商品原融(優質)14％' },
        { key: 'DQ79', busType: 'CA20', text: 'DQ79-OA商品原融(一般)15％' },
        // 新 8/9 CA20
        { key: 'DQ71', busType: 'AA21', text: 'DQ71-OA機車原融(N專案)_超優13.5％' },
        { key: 'DQ72', busType: 'AA21', text: 'DQ72-OA機車原融(N專案)_優質14％' },
        { key: 'DQ73', busType: 'AA21', text: 'DQ73-OA機車原融(N專案)_一般15％' },
        // 新 10/2 CA20
        { key: 'DR47', busType: 'AA21', text: 'DR47-OA機車原融(N專案)_超優13.5％' },
        { key: 'DR48', busType: 'AA21', text: 'DR48-OA機車原融(N專案)_優質14％' },
        { key: 'DR49', busType: 'AA21', text: 'DR49-OA機車原融(N專案)_一般15％' },
        // 嘉好自有
        { key: 'CC210', busType: 'CC21', text: '新車分期' },
        { key: 'CC220', busType: 'CC21', text: '中古車分期' },
        { key: 'CC220', busType: 'CC21', text: '延長期數專案' },
        // 21世紀
        { key: 'C021', busType: 'C21', text: '商品原融' },
      ];
    },
    isTimeAdmin() {
      return this.getUserInfo.enableToken === true && this.getUserInfo.token !== '';
    },
    isAdmin() {
      return this.getUserInfo.authority === 'admin';
    },
    isManager() {
      return this.getUserInfo.authority === 'manager';
    },
    isAgent() {
      return this.getUserInfo.authority === 'agent';
    },
    isSales() {
      return this.getUserInfo.authority === 'sales';
    },
    isStore() {
      return this.getUserInfo.authority === 'store';
    },
    isAccounting() { // 會計
      return this.getUserInfo.authority === 'accounting';
    },
    isStaff() {
      return this.getUserInfo.authority === 'staff';
    },
    isInsureAgent() {
      return this.getUserInfo.authority === 'insureAgent';
    },
    canEditCommissionTarget() {
      return this.getUserInfo && this.getUserInfo.enableEditCommissionTarget;
    },
    canEditCompanyDoc() {
      return this.getUserInfo && this.getUserInfo.enableCompanyDoc;
    },
    getMemberIdCityList() {
      return [
        { key: '1', value: '北縣' },
        { key: '10', value: '嘉縣' },
        { key: '11', value: '南縣' },
        { key: '12', value: '高縣' },
        { key: '13', value: '屏縣' },
        { key: '14', value: '東縣' },
        { key: '15', value: '花縣' },
        { key: '16', value: '澎縣' },
        { key: '17', value: '基市' },
        { key: '18', value: '竹市' },
        { key: '19', value: '中市' },
        { key: '2', value: '宜縣' },
        { key: '20', value: '嘉市' },
        { key: '21', value: '南市' },
        { key: '22', value: '連江' },
        { key: '23', value: '金門' },
        { key: '24', value: '北市' },
        { key: '25', value: '高市' },
        { key: '26', value: '新北市' },
        { key: '27', value: '桃市' },
        { key: '3', value: '桃縣' },
        { key: '4', value: '竹縣' },
        { key: '5', value: '苗縣' },
        { key: '6', value: '中縣' },
        { key: '7', value: '彰縣' },
        { key: '8', value: '投縣' },
        { key: '9', value: '雲縣' },
      ];
    },
    paymentList() {
      return [
        { key: 0, text: '現金' },
        { key: 1, text: '簽單' },
        { key: 2, text: '超商繳款' },
        { key: 3, text: '信用卡' },
        { key: 4, text: '金融卡' },
        { key: 5, text: 'QRCode' },
        { key: 6, text: '郵局到付' },
        { key: 7, text: '大榮貨運付款' },
      ];
    },
    paymentStatusList() {
      return [
        { key: 0, text: '未付款' },
        { key: 1, text: '已付款' },
        { key: 2, text: '退貨' },
      ];
    },
    deliveryStatusList() {
      return [
        { key: 0, text: '未出貨' },
        { key: 1, text: '已退貨' },
        { key: 2, text: '已出貨' },
        { key: 3, text: '已作廢' },
        { key: 4, text: '交換貨' },
      ];
    },
    vendorList() {
      return [
        { key: 0, value: '光陽', text: '光陽' },
        { key: 1, value: '三陽', text: '三陽' },
      ];
    },
    getContactTimeList() {
      return [
        { key: 0, text: '聯絡時間' },
        { key: 1, text: '09:00~12:00' },
        { key: 2, text: '12:00~18:00' },
        { key: 3, text: '18:00~21:00' },
        { key: 4, text: '21:00~23:00' },
        { key: 5, text: '隨時都可以' },
      ];
    },
  },
  methods: {
    ...mapActions(['updateFinanceData', 'saveMarketPaymentInfo']),
    getEducation(customer) {
      if (customer.educationLevel[0].value) {
        return '博士';
      }
      if (customer.educationLevel[1].value) {
        return '碩士';
      }
      if (customer.educationLevel[2].value) {
        return '大學';
      }
      if (customer.educationLevel[3].value) {
        return '專科';
      }
      if (customer.educationLevel[4].value) {
        return '高中職';
      }
      if (customer.educationLevel[5].value) {
        return '其他';
      }
      return customer.education ? customer.education : '';
    },
    async createMarketPaymentInfo(firstPaymentDate, order) {
      let date = '';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < order.period; i++) {
        const monthPrice = order.total; // Math.floor(order.total / order.period);
        if (i === 0) {
          if (firstPaymentDate !== '') {
            date = firstPaymentDate;
          } else {
            date = addMonth(`${getCurrentDate()}`);
          }

          const item = { no: (i + 1),
            price: monthPrice,
            paymentDate: date,
            virtualAccount: MarketPaymentTool.getVirtualAccount(monthPrice),
            barCode1: `${MarketPaymentTool.getBarCode1(monthPrice)}`,
            barCode2: '',
            barCode3: '',
          };
          item.barCode2 = `00${item.virtualAccount}`;
          item.barCode3 = `${MarketPaymentTool.getBarCode3(item.barCode1, item.barCode2, item.price)}`;
          item.barCode4 = item.virtualAccount;
          order.paymentList.push(item);
        } else {
          date = addMonth(date);
          const item = { no: (i + 1),
            price: monthPrice,
            paymentDate: date,
            virtualAccount: MarketPaymentTool.getVirtualAccount(monthPrice),
            barCode1: `${MarketPaymentTool.getBarCode1(monthPrice)}`,
            barCode2: '',
            barCode3: '',
          };
          item.barCode2 = `00${item.virtualAccount}`;
          item.barCode3 = `${MarketPaymentTool.getBarCode3(item.barCode1, item.barCode2, item.price)}`;
          item.barCode4 = item.virtualAccount;
          order.paymentList.push(item);
        }
      }
      console.log(`order = ${JSON.stringify(order)}`);
      this.loading = true;
      const res = await this.saveMarketPaymentInfo(order);
      const result = res.data;
      this.loading = false;
      return result;
    },
    showMessageDialog(message) {
      NoticeManager.notifyObservers('showAlert', {
        title: '提示',
        text: message,
        visible: true,
        showCancelButton: false,
      });
    },
    getBeforePrice(itemDetail) { // 內扣款
      let beforePrice = 0;
      // platform 0裕富 1:和潤 2:中租 3創巨 4嘉好自有 5：21世紀
      console.log(`itemDetail == ${JSON.stringify(itemDetail)}`);
      const category = this.findCategory(itemDetail.promotionNo, itemDetail.promotionType);
      console.log(`getBeforePrice = ${category} | ${itemDetail.promotionNo}`);
      if (itemDetail.platform === 1 || itemDetail.platform === 2) {
        beforePrice = 5500;
      } else if (itemDetail.promotionNo === 'DQ77' || itemDetail.promotionNo === 'DQ78' || itemDetail.promotionNo === 'DQ79'
        || itemDetail.promotionNo === 'DQ71' || itemDetail.promotionNo === 'DQ72' || itemDetail.promotionNo === 'DQ73') {
        beforePrice = 7000;
      } else if (itemDetail.promotionNo === 'DQ74' || itemDetail.promotionNo === 'DQ01' || itemDetail.promotionNo === 'DQ02' || itemDetail.promotionNo === 'DQ03'
        || itemDetail.promotionNo === 'DQ04' || itemDetail.promotionNo === 'DQ05' || itemDetail.promotionNo === 'DQ06' || itemDetail.promotionNo === 'DQ07'
        || itemDetail.promotionNo === 'DR47' || itemDetail.promotionNo === 'DR48' || itemDetail.promotionNo === 'DR49') {
        beforePrice = 5000;
      } else {
        let beforePercent = 9; // 預設9%
        if (itemDetail.promotionNo === 'DQ18' || itemDetail.promotionNo === 'DQ19') {
          beforePercent = 5;
        } else if (itemDetail.promotionNo === 'DQ20') {
          beforePercent = 7;
        }
        // eslint-disable-next-line radix
        const n1 = parseInt(itemDetail.totalPrice ? itemDetail.totalPrice : 0);
        // eslint-disable-next-line no-mixed-operators
        beforePrice = Math.ceil(n1 * beforePercent / 100);
      }
      return beforePrice;
    },
    findCategory(promotionNo, promotionType) {
      // eslint-disable-next-line max-len
      const find = this.getFinanceCaseViewList.find(i => i.key === promotionNo && i.busType === promotionType);
      if (find) {
        return find.text;
      }
      return '查無分類';
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mixins/common.vue